import { ContentContainer } from "@/components/ContentContainer";
import { Spinner } from "@/components/Spinner";
import PlaylistInfos from "@/components/playlist/PlaylistInfos";
import { PlaylistSuchenFilter } from "@/components/playlist/PlaylistSuchenFilter";
import { PlaylistSuchenResults } from "@/components/playlist/PlaylistSuchenResults";
import { getPlaylists, usePlaylist } from "@/lib/api";
import { Grid } from "@mui/material";
import Error from "next/error";
import { useState } from "react";
const { useRouter } = require("next/router");

const Playlist = ({ page }) => {
  const router = useRouter();
  const { slug } = router.query;
  const { playlist, isLoading, isError } = usePlaylist(slug);
  const [filter, setFilter] = useState("");

  const handlePlaylistChanged = (newPlaylist) => {
    if (newPlaylist.id !== playlist.id) {
      router.push(`/playlist/${newPlaylist.slug}`);
    }
  };

  if (isLoading) return <Spinner />;
  if (isError) return <Error />;
  if (!playlist) {
    return <Error statusCode={404} />;
  }

  return (
    <ContentContainer
      headline={
        playlist.name ||
        (playlist.type === "usergenerated"
          ? "Geteilte Playlist"
          : playlist.title)
      }
      subheadline={playlist.type !== "usergenerated" && "Playlist"}
      image={page?.hero_image?.formats?.large?.url}
    >
      <Grid container spacing={{ xs: 1, sm: 3 }}>
        <Grid item xs={12} md={4}>
          <PlaylistInfos playlist={playlist} />
          <PlaylistSuchenFilter
            playlist={playlist}
            onPlaylistChanged={handlePlaylistChanged}
            onFilterChanged={(filter) => {
              setFilter(filter);
            }}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <PlaylistSuchenResults playlist={playlist} filter={filter} />
        </Grid>
      </Grid>
    </ContentContainer>
  );
};

export async function getStaticProps(context) {
  const baseUrl = `${
    process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"
  }`;
  const pageResponse = await fetch(`${baseUrl}/page-music-explore`);
  const page = await pageResponse.json();

  return {
    props: {
      page,
    },
    revalidate: parseInt(process.env.SSG_REVALIDATE_PLAYLISTS),
  };
}

export async function getStaticPaths() {
  const playlists = await getPlaylists();

  // Get the paths we want to pre-render based on posts
  const paths = playlists.map((playlist) => ({
    params: { slug: playlist.slug },
  }));

  // We'll pre-render only these paths at build time.
  // { fallback: 'blocking' } will server-render pages
  // on-demand if the path doesn't exist.
  return { paths, fallback: "blocking" };
}

export default Playlist;
